<template>
  <modal-base
    ref="modal"
    title="Attach Lead"
    :short-circuit-close="true"
    @close="cancel"
    is-double-column
  >
    <section-box>
      <add-record-to-contact-form
        ref="addRecordToContactForm"
        @changeIsExistingRecord="isExistingRecord = $event"
        @saved="confirmed"
        @errored="failed"
      ></add-record-to-contact-form>
    </section-box>

    <template v-slot:footer>
      <button-default
        v-if="isExistingRecord"
        @click="attachedLead"
        :loading="isSaving"
      >Attach Lead</button-default>

      <button-default
        v-else
        @click="attachedLead"
        :loading="isSaving"
      >Create & Attach Lead</button-default>
    </template>
  </modal-base>
</template>

<script>
import {destroyModal} from "../../../services/modals";
import ModalBase from "../../../components/modal/ModalBase";
import AddRecordToContactForm from "../../../forms/AddRecordToContactForm";

export default {
  name: "AttachLeadToContactModal",
  components: {
    ModalBase,
    AddRecordToContactForm
  },
  data() {
    return {
      isSaving: false,
      isExistingRecord: true,
    }
  },
  mounted() {
    this.$refs.modal.open();
  },
  methods: {
    attachedLead() {
      this.isSaving = true;
      this.$refs.addRecordToContactForm.save().then(() => {
        this.isSaving = false;
      });
    },
    confirmed() {
      this.$emit('confirmed');
      destroyModal(this.$refs.modal);
    },
    failed() {
      this.isSaving = false;
    },
    cancel() {
      this.$emit('canceled');
      destroyModal(this.$refs.modal);
    },
  }
}
</script>

<style scoped>

</style>
